import { ConnectionDataSet } from '../DataSet/Connection';
import { IDataHandler } from '../IDataHandler';
import { allTrackingEvents, ConnectionEventName, DataRestoreEventName, TrackingEventName } from '../TrackingEvent';

type tDataSetKey = keyof ConnectionDataSet;

export const ConnectionDataMap: Map<allTrackingEvents, tDataSetKey[]> = new Map<allTrackingEvents, tDataSetKey[]>([
    [ConnectionEventName.gbFail, ['gbSessionNumber', 'gbError']],
    [ConnectionEventName.gbReconnect, ['gbSessionNumber', 'gbDisconnectTime', 'gbInitializeTime']],
    [TrackingEventName.gameLoaded, ['gbInitializeTime', 'gbFailBeforeSuccess']],
    [TrackingEventName.gameStarted, ['gbInitializeTime', 'gbFailBeforeSuccess']],
]);

export class ConnectionDataHandler implements IDataHandler<ConnectionDataSet> {
    public data = new ConnectionDataSet();

    public getEventData(eventName: ConnectionEventName): ConnectionDataSet {
        const data: ConnectionDataSet = ConnectionDataMap.get(eventName).reduce((acc, key) => {
            acc[key] = this.data[key] as never;
            return acc;
        }, {} as ConnectionDataSet);

        // Reset data.
        if (eventName === ConnectionEventName.gbFail) {
            this.clearData();
        }

        return data;
    }

    public clearData(): void {
        this.data = new ConnectionDataSet();
    }
}
